import { render, staticRenderFns } from "./QuickViews.vue?vue&type=template&id=66b0cd44"
import script from "./QuickViews.vue?vue&type=script&lang=js"
export * from "./QuickViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports